import { IMedication, IPrescriptionsMedication, api } from './index';
import { addImposterToUrl, downloadFile } from 'Utils';
const baseUrl = '/Prescription';

export interface IPrescriptionMedicationHistory extends IPrescriptionStatuses {
  createDate: Date;
  code: number;
  dosage: number;
  doseperday: number;
  fornumberdays: number;
  medremark?: any;
  status: number;
  recordStatus: number;
  ratificationDate: string;
  supplyind: number;
  superPharmReceiveDate: string;
  internetCode?: number;
  effectiveDate?: Date;
  providerTransmissionDate?: Date;
  returenSign?: number;
  urgent?: number;
  notSupply?: number;
  eligibleNotes?: string;
  broadcastType?: number;
  doctorNotes?: string;
  medicationCount?: number;
  narcotind?: boolean;
}

export interface IMedicationHistory {
  medicationCode: number;
  medicationName: string;
  prescriptions: IPrescriptionMedicationHistory[];
  nextRefreshDate: string;
  onceInd?: number;
}

export interface IPresTruncatedDataDTO {
  originalOrderId?: number;
  prescCode?: number;
  createDate: Date | string;
  originalOrderStartIsrDate?: Date;
  eligibleNotes?: string;
  itemsCount?: number;
  currentStatus: number;
  currentStatusDate?: Date;
  currentStatusLabel?: string;
  adminIsrId?: string;
  isManual: boolean;
  notSupply?: number;
  medications?: IMedication[];
}

export interface IMedConfirmationFile {
  id: number;
  file: string;
}

export const getMedConfirmationData = async () => {
  let response = await api.get<IMedConfirmationFile>(
    addImposterToUrl(`MedicationsPdf/PresMedConfirmationData`, true),
  );
  return response;
};

export const exportToPdf = async () => {
  let response = await api.get<IMedConfirmationFile>(
    addImposterToUrl(`MedicationsPdf/PresMedConfirmationData`, true),
  );
  if (response?.data?.file)
    downloadFile(response.data.file, '.pdf', 'medication history');
};

export const searchMedicationHistory = async () => {
  const medicationHistory = await api.get<IMedicationHistory[]>(
    addImposterToUrl(`${baseUrl}/search`, true),
  );
  if (medicationHistory.data) {
    return medicationHistory.data;
  }
};

export const getPrescriptions = async () => {
  const prescriptions = await api.get<IPrescription[]>(
    addImposterToUrl(baseUrl, true),
  );
  if (prescriptions.data) return prescriptions.data;
};

export interface ILastOrderId {
  internetRequestNumber: number;
}

export const getLastOrderId = async () => {
  const lastOrderId = await api.get<ILastOrderId>(
    addImposterToUrl(`${baseUrl}/latest-opened-id`, true),
  );

  return lastOrderId?.data || null;
};

export type RECORD_STATUS = 1 | 4 | 5 | 8;

export type Statuses = {
  statusDate?: string;
  calcStatus: number;
  label: string;
  description?: string;
};

export interface IPrescriptionStatuses {
  isManual: boolean;
  currentStatus: number;
  statuses: Statuses[];
}

export interface IPrescription extends IPrescriptionStatuses {
  code: number;
  internetCode?: number;
  status: number;
  recordStatus: RECORD_STATUS;
  effectiveDate?: Date;
  createDate: string;
  ratificationDate?: Date;
  providerTransmissionDate?: Date;
  superPharmReceiveDate?: Date;
  returenSign?: number;
  urgent?: number;
  notSupply?: number;
  eligibleNotes?: string;
  broadcastType?: number;
  doctorNotes?: string;
  medicationCount?: number;
  medications: IPrescriptionsMedication[];
}
